require('dayjs/locale/pt-br');
require('dayjs/locale/en');
require('dayjs/locale/es');
import ptBR from '@/locales/datepicker/pt-BR';
import en from '@/locales/datepicker/en';
import es from '@/locales/datepicker/es';
import dayjs from 'dayjs';
import bus from '@/helpers/events/bus';
import store from '@/store';
const formatLanguage = (langauge) => {
    if (!langauge)
        return;
    return dayjs().locale(langauge).format();
};
export const datepickerLanguage = (language) => {
    let locale;
    switch (language) {
        case 'pt-BR':
            locale = ptBR;
            break;
        case 'es':
            locale = es;
            break;
        case 'en':
        default:
            locale = en;
            break;
    }
    formatLanguage(language);
    return locale;
};
export const datepickerUpdate = (newDates) => {
    const dates = {
        startDate: newDates[0],
        endDate: newDates[1],
    };
    const initialDay = dayjs(dates.startDate);
    const finalDay = dayjs(dates.endDate);
    const numberOfDays = finalDay.diff(initialDay, 'day');
    store.dispatch('changeDates', dates);
    store.dispatch('salesReportNew/setResetSegmentsIds');
    store.dispatch('engagementReport/setResetFilterIds');
    bus.$emit('render-cards', numberOfDays);
};
